module.exports = __webpack_public_path__ + "img/a-universe-of-endless-possibilities.c780a66a.jpg";